<template>

  <b-card

    :header="(this.treatmentConfig[0] && ( country === 'MX'? this.treatmentConfig[0].label_category: this.$i18n.t('proposal.Treatment'))) || this.$i18n.t('proposal.Treatment')"
    class="text-center"

    v-if="typeCard === 'Multiple'"
  >

    <div class="text-center" v-if="isLoading || isLoadingProducts">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <b-card-text v-else>
      <div class="search-product">
        <div class="groupSearch mb-3">
          <b-input-group size="sm" class="inputSearch">
            <b-form-input
              id="search-treatment"
              v-model="filterOptions"
              type="search"
              :placeholder="this.$i18n.t('welcome.search')"
              class="custom-input"
            >
            </b-form-input>
          </b-input-group>
        </div>
        <hr />
        <div class="title-items">
          <span>{{ $t('proposal.Article') }}</span>
          <span>{{ $t('proposal.Price') }} ({{ country === 'MX' ? 'MXN ' : 'USD ' }})</span>
        </div>
      </div>
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          id="checkbox-group-treatment"
          v-model="treatmentSelected"
          :aria-describedby="ariaDescribedby"
          name="treatment"
          stacked
        >
          <b-form-checkbox
            v-for="(item, index) in treatments"
            :value="item.value"
            :key="'treatments-' + index"
          >
            <template v-if="item.top">
              <b class="b-ingen"><span v-if="proposalingen.msg != null || proposalingen.msg != undefined" class="no-ingen" >
                <label :class="{ 'ingenes-class': proposalingen.msg.find(x => x.cfgd_articulo == item.text && x.cfgd_Categoria == item.value.Categoria) }">
                  {{ item.text }}
                    <b
                    ><span class="text-secondary">{{ formatPrice(item.value.PrecioLista) }}</span>
                </b>
                <hr v-if="amountTop - 1 === index" /> 
                    
                </label>
              </span>
              
              <span v-else class="no-ingen">
                {{item.text}} <b
                  ><span class="text-secondary">{{ formatPrice(item.value.PrecioLista) }}</span>
                </b> 
              </span></b>   
            </template>
            <template v-else>
              <span v-if="proposalingen.msg != null || proposalingen.msg != undefined" class="no-ingen" >
                <label :class="{ 'ingenes-class': proposalingen.msg.find(x => x.cfgd_articulo == item.text && x.cfgd_Categoria == item.value.Categoria) }">
                  {{item.text}}<b
                    ><span class="text-secondary">{{ formatPrice(item.value.PrecioLista) }}</span>
                  </b>
                </label>
              </span>
              <span v-else class="no-ingen">
                {{item.text}}<b
                  ><span class="text-secondary">{{ formatPrice(item.value.PrecioLista) }}</span>
                </b>
              </span>
            </template>
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <p v-if="!treatments.length" class="my-2">No result for treatments</p>
    </b-card-text>
  </b-card>

  <b-card
    :header="(this.treatmentConfig[0] && ( country === 'MX'? this.treatmentConfig[0].label_category: this.$i18n.t('proposal.Treatment'))) || this.$i18n.t('proposal.Treatment')"
    class="text-center"
    @change="getRadioValues"
    v-else
  >
    <div class="text-center" v-if="isLoading || isLoadingProducts">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <b-card-text v-else>
      <div class="search-product">
        <div class="groupSearch mb-3">
          <b-input-group size="sm" class="inputSearch">
            <b-form-input
              id="search-treatment"
              v-model="filterOptions"
              type="search"
              :placeholder="this.$i18n.t('welcome.search')"
              class="custom-input"
            >
            </b-form-input>
          </b-input-group>
        </div>

        <hr />
      </div>
      <b-form-radio-group
        v-model="treatmentSelected"
        v-slot="{ ariaDescribedby }"
        v-for="(item, index) in treatments"
        :key="index"
      >
        <b-form-radio
          :aria-describedby="ariaDescribedby"
          :name="item.category"
          :value="item"
        >
           <template v-if="item.top">
              <b>{{ item.text }} <hr v-if="amountTop - 1 === index"/> </b><b><span class="text-secondary">{{formatPrice(item.value.PrecioLista)}}</span> </b></template
            >
          <template v-else>{{ item.text }}<b><span class="text-primary ml-3">Precio: </span> {{formatPrice(item.value.monedaPrecio, item.value.PrecioLista)}}</b></template>
        </b-form-radio>
      </b-form-radio-group>
      <p v-if="!treatments.length" class="my-2">No result for treatments</p>
      <b-button size="sm" variant="outline-danger" @click="resetCheck"
        >Reset</b-button
      >
    </b-card-text>
  </b-card>
</template>

<script>
import { AlertForm, ICON } from "../../helpers/Alert";
import { NumberFormat } from '../../helpers/NumberFormat';
import { ApiRequest } from '../../helpers/ApiRequest';
import { API_PRODUCTO_CATEGORIA } from '../../Constants/Api';


export default {
  name: "TreatmentSection",
  props: [
    "dataProducts",
    "isLoadingProducts",
    "topProducts",
    "treatmentConfig", 
    'proposalingen'
  ],
  data() {
    return {
      treatmentSelected: [],
      treatments: [],
      allTreatments: [],
      country: "",
      listArticles: [],
      filterOptions: "",
      isLoading: false,
      amountTop: null,
      typeCard: "Multiple",
    };
  },

  async mounted() {
    this.country = sessionStorage.getItem("country");
    this.listArticles =
      JSON.parse(sessionStorage.getItem("arregloArticulos")) || [];
    await this.updateTreatments();
    await this.propuestaIngenesTratamientos();
  },
  watch: {
    treatmentSelected() {
      
        let arrayArticles =
        JSON.parse(sessionStorage.getItem("arregloArticulos")) || [];

        arrayArticles = arrayArticles.filter(
          (el) => !["TREATMENT"].includes(el.name)
        );
        if(this.treatmentSelected.length) {
          if (this.typeCard === "Multiple") {
            this.treatmentSelected.forEach((el) => {
              arrayArticles.push({
                name: el.Categoria,
                value: el.Articulo,
                amount: "1",
                description: el.CodigoAlterno,
                price: el.PrecioLista.toString(),
                currencyFormat: el.monedaPrecio,
                data: el,
              });
            });
          }
        }
        sessionStorage.setItem("arregloArticulos", JSON.stringify(arrayArticles));
      
    },
    async dataProducts() {
      await this.updateTreatments();
    },
    async topProducts() {
      await this.updateTreatments();
    },
    async treatmentConfig() {
      setTimeout(() => {
        this.updateTreatments();
      }, 2000);
    },
    filterOptions() {
      this.treatments = this.allTreatments.filter((el) =>
        el.text.toLowerCase().includes(this.filterOptions.toLowerCase())
      );
      this.amountTop = this.treatments.filter((el) => el.top === true).length;
    },
  },
  methods: {
    async updateTreatments() {
      try {
        let dataTreatment = [];
        this.isLoading = true;
        if (this.treatmentConfig.length) {
          dataTreatment = this.treatmentConfig;
          this.typeCard = this.treatmentConfig[0].tipocard;
        } else {
          if (this.topProducts !== null) {
            dataTreatment = this.topProducts;
          } else if (this.country === 'US') {
            let data = await ApiRequest.get(`${API_PRODUCTO_CATEGORIA}TREATMENT`);
            dataTreatment = data.productos;
          } else {
            dataTreatment = this.dataProducts;
          }
        }

        let cantidad = 0;
        this.treatments = dataTreatment.map((el) => {
          if (el.isTop) cantidad++;
          return {
            text: el.CodigoAlterno,
            value: el,
            top: el.isTop ? true : false,
          };
        });
        this.amountTop = cantidad;
        this.allTreatments = this.treatments;
        // let filterTreatment = this.listArticles.filter((el) => ["TREATMENT"].includes(el.name));
        let filterTreatment = this.listArticles.filter((el) => el.name === 'TREATMENT');


        filterTreatment = filterTreatment.map((el) => {
          return el.description;
        });

        filterTreatment = this.treatments.filter((el) => filterTreatment.includes(el.text));

        this.treatmentSelected = filterTreatment.map((el) => el.value);
        if (this.typeCard === 'Unico' && this.treatmentSelected.length) {
          this.treatmentSelected = {
            text: this.treatmentSelected[0].CodigoAlterno,
            top: this.treatmentSelected[0].isTop,
            value: this.treatmentSelected[0],
          };
        }
      } catch (err) {
        AlertForm(`Error Code: ${err.status || ''}`, err.statusText, ICON.ERROR);
      } finally {
        this.isLoading = false;
      }
    },
    getRadioValues() {
      const arrayArticles = JSON.parse(
        sessionStorage.getItem("arregloArticulos")
      );
      //const filterTreatment = arrayArticles.filter((el) => !['TREATMENT'].includes(el.name));
      const filterTreatment = arrayArticles.filter((el) => el.name !== 'TREATMENT');

      let dataSelected = {
        amount: "1",
        currencyFormat: this.treatmentSelected.value.monedaPrecio,
        description: this.treatmentSelected.text,
        name: this.treatmentSelected.value.Categoria,
        price: this.treatmentSelected.value.PrecioLista,
        top: this.treatmentSelected.top,
        value: this.treatmentSelected.value.Articulo,
        data: this.treatmentSelected.value,
      };
      filterTreatment.push(dataSelected);
      sessionStorage.setItem("arregloArticulos", JSON.stringify(filterTreatment));
    },
    resetCheck() {
      this.treatmentSelected = "";

      const arregloArticulos = JSON.parse(
        sessionStorage.getItem("arregloArticulos")
      );
      sessionStorage.setItem(
        "arregloArticulos",
        JSON.stringify(arregloArticulos.filter((el) => el.name !== "TREATMENT"))
      );
    },
    formatPrice(price) {
      return NumberFormat(price);
    },
    propuestaIngenesTratamientos(){
      if(this.proposalingen.msg != null || this.proposalingen.msg != undefined){
        if (this.proposalingen.msg.length) {
          this.treatments.forEach(item => {
            let laboratoryIngen = this.proposalingen.msg.find(x => x.cfgd_articulo == item.text && x.cfgd_Categoria == item.value.Categoria)  
            if(laboratoryIngen != null){
              let exist = this.treatmentSelected.find(x => x.CodigoAlterno == laboratoryIngen.cfgd_articulo && x.Categoria == laboratoryIngen.cfgd_Categoria);
              if(exist == null || exist == undefined){
                this.treatmentSelected.push(item.value);
              }    
            }
          }); 
        }
      }
    }
  },
};
</script>

<style scoped>
@import "../../assets/css/global.css";
@import "../../assets/css/proposal.css";

.groupSearch {
  width: 50%;
}
</style>
